import React from "react";

const palette = {
    primary: { text: "text-blue-700", border: "border-blue-600" },
    gray: { text: "text-gray-800", border: "border-gray-400" },
    red: { text: "text-[#9f2b45]", border: "border-[#9f2b45]" },

};

const alignMap = { left: "text-left", center: "text-center", right: "text-right" };

export default function QuoteBlock({
    children,
    tone = "primary",
    align = "left",
    className = "",
}) {
    const c = palette[tone] || palette.primary;
    const ta = alignMap[align] || alignMap.left;

    return (
        <blockquote className={`border-l-4 pl-4 font-bold leading-relaxed my-6 ${c.text} ${c.border} ${ta} ${className}`}>
            {children}
        </blockquote>
    );
}
